import React from "react";
import styles from "./Auth.module.css";

function InputField({ desc, type, name, placeholder, required, value, onChange }) {
    return (
        <div className={styles["input"]}>
            <p className={styles["input-desc"]}>
                {desc}
            </p>

            <input 
                type={type}
                className={styles["input-field"]}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required={required}
            />
        </div>
    )
}

export default InputField;